import React, { useEffect, useRef } from 'react';
import { Container, Button, Row, Col, Carousel } from 'react-bootstrap';
import { FaWhatsapp, FaGoogle, FaStar } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import './Pisos.css';

// --------------------------------------------------------
// 1. SUB-COMPONENTES PUROS (Afuera de la función principal)
// --------------------------------------------------------
const mainPhone = "542215739000";

const ContactButton = ({ text = "HABLA CON UN ASESOR", variant = "danger", className = "" }) => (
  <Button 
    href={`https://wa.me/${mainPhone}?text=${encodeURIComponent("Hola Darom SA, estoy interesado en sus soluciones de pisos industriales DRM 360™. ¿Podrían enviarme más información y una cotización personalizada?")}`}  
    target="_blank"
    rel="noopener noreferrer"
    className={`cta-button my-3 fw-bold ${variant} ${className}`}
  >
    <FaWhatsapp className="me-2" size={20} /> {text}
  </Button>
);

// Pastilla de Google Maps estandarizada
const GoogleRatingBadge = () => (
  <div className="d-flex justify-content-center w-100 mt-3">
    <a 
      href="#reviews" 
      className="d-inline-flex align-items-center text-decoration-none py-2 px-4 shadow-lg bg-white rounded-pill" 
      style={{ transition: 'transform 0.2s', width: 'auto', whiteSpace: 'nowrap' }}
      onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
      onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
    >
      <FaGoogle className="text-danger me-2" size={20} />
      <div className="d-flex align-items-center mx-2 border-end border-secondary border-opacity-25 pe-3">
        <span className="fw-bold fs-5 me-1" style={{ color: '#212529' }}>4.7</span>
        <FaStar className="text-warning" size={18} />
      </div>
      <span className="small ms-2 fw-bold" style={{ color: '#495057' }}>50+ Reseñas Verificadas</span>
    </a>
  </div>
);

// Micro-componente creado para no repetir el SVG 4 veces en el CTA Final
const CheckListItem = ({ text }) => (
  <div className="d-flex align-items-center justify-content-center mb-3">
    <span className="me-3" style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      background: 'white',
      flexShrink: 0
    }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path d="M5 13L9 17L19 7" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </span>
    <span>{text}</span>
  </div>
);

// --------------------------------------------------------
// 2. DATOS ESTÁTICOS (Afuera de la función principal)
// --------------------------------------------------------
const suppliers = [
  { src: '/logolomanegra.png', alt: 'Loma Negra' },
  { src: '/LOGOSIKA.png', alt: 'Sika' },
  { src: '/logoacindarofi.png', alt: 'Red Acindar' },
  { src: '/logodafre.jpg', alt: 'Dafre' },
  { src: '/logo varsovia.jpg', alt: 'Grupo Varsovia' },
  { src: '/LOGOTECMA.PNG', alt: 'Tecma' },
  { src: '/logoeleprint.png', alt: 'Eleprint' },
  { src: '/logogoldir.png', alt: 'Goldir' },
  { src: '/dycasalogo.jpg', alt: 'Ieb Construcciones' },
  { src: '/logoaubasa.png', alt: 'Aubasa' },
  { src: '/logopfisterer.png', alt: 'Pfisterer' },
  { src: '/logoweber.png', alt: 'Weber' },
  { src: '/logofanelli.png', alt: 'Fanelli' },
  { src: '/logoctibor.png', alt: 'Ctibor' }
];

const testimonios = [
  { text: "Los mejores! Compré todo el hierro, ladrillos y materiales para mi casa. Llené la platea y 3 losas de hormigón con ellos, todo impecable. Destaco la atención, productos y servicio de entrega.", author: "Pablo Laurito" },
  { text: "Muy buena atención. Eficacia, rapidez y puntualidad en la entrega. Excelente logística para satisfacer las necesidades de sus clientes.", author: "Sebastian Godoy" },
  { text: "Excelente servicio de atención, entregas sin demoras y seguimiento de pedidos. Respuesta inmediata y asesoramiento técnico especializado.", author: "Grupo Varsovia" },
  { text: "Cumplieron con los tiempos y lo pactado. Destaco la excelente predisposición y programación impecable de Guillermo.", author: "Laura Scandroglio" },
  { text: "La atención y comunicación son impecables. Gran predisposición para resolver problemas técnicos. Altamente recomendable.", author: "Arq. De los Santos" },
  { text: "Excelente atención y predisposición para asesorar en materiales de construcción.", author: "Matias Muchenik" },
  { text: "Resalto la atención de Aixa: profesional, predispuesta y resolutiva. Muy satisfecho con el servicio.", author: "Manuel Garriga" },
  { text: "Excelente servicio. Comunicación clara y logística eficiente para obras de gran envergadura.", author: "Claudio Castiglia" },
  { text: "Los mejores precios y servicio en 20 años. Siempre que puedo, elijo trabajar con ellos por su seriedad.", author: "Emmanuel Bor" },
  { text: "Atención rápida y soluciones a medida para proyectos arquitectónicos complejos.", author: "Goldir" },
  { text: "Equipo confiable y detallista. Materiales de primera calidad para estructuras exigentes.", author: "German Luiso" }
];

const obras = [
  "/obra34.png", 
  "/portadapisollaneado2.jpeg", 
  "/portadaserviciopluma.jpg", 
  "/portadahormigonbombeo.jpg", 
  "/obra50.png", 
  "/portadahormigonoficial.JPG"
];

const paquetesData = [
  {
    title: "OFERTA 1 — PAQUETE BASE",
    subtitle: "Diagnóstico preciso y base compactada con garantía certificada",
    features: [
      "Relevamiento Topográfico Técnico (100% bonif.)",
      "Estudio Geotécnico Certificado (50% bonif.)",
      "Preparación y Movimiento de Suelos",
      "Ensayos de compactación incluidos"
    ],
    garantia: "Compactación Certificada: Re-ejecución sin costo",
    premium: false
  },
  {
    title: "OFERTA 2 — SOLUCIÓN INDUSTRIAL",
    subtitle: "Piso industrial listo en tiempo y forma con control total",
    features: [
      "Todo lo del Paquete Base +",
      "Hormigón con Macrofibra Sika Fiber 48™",
      "Control Hormigón Certificado DRM360™",
      "Mano de Obra Especializada con nivelación láser de alta precisión"
    ],
    garantia: "FullCover™ 5 Años: Corrección sin costo",
    premium: true
  },
  {
    title: "OFERTA 3 — ULTRAFLOOR PRO™",
    subtitle: "Máxima resistencia con 10 años de garantía estructural",
    features: [
      "Todo lo del Paquete Industrial +",
      "Terminación Sika Professional™",
      "Mantenimiento preventivo por 3 años",
      "Hormigón de ultra resistencia"
    ],
    garantia: "FullCover™ 10 Años: Garantía extendida",
    premium: false
  }
];

// --------------------------------------------------------
// 3. COMPONENTE PRINCIPAL
// --------------------------------------------------------
function Pisos() {
  const videoRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const video = videoRef.current;
    if (!video) return;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const handleLoadedData = () => {
      if (!isMobile) {
        video.play().catch(e => console.log("Auto-play prevented:", e));
      }
    };

    const handleFirstInteraction = () => {
      if (isMobile && video.paused) {
        video.play().catch(e => console.log("Play after interaction prevented:", e));
        document.removeEventListener('click', handleFirstInteraction);
        document.removeEventListener('touchstart', handleFirstInteraction);
      }
    };

    video.addEventListener('loadeddata', handleLoadedData);
    document.addEventListener('click', handleFirstInteraction);
    document.addEventListener('touchstart', handleFirstInteraction);

    return () => {
      video.removeEventListener('loadeddata', handleLoadedData);
      document.removeEventListener('click', handleFirstInteraction);
      document.removeEventListener('touchstart', handleFirstInteraction);
    };
  }, []);

  return (
    <Container fluid className="px-0 pisos-container">
      <Helmet>
        <title>Pisos Industriales Premium | Estudio y Ejecución | Darom SA</title>
        <meta name="description" content="Primer hormigonera que desarrolla tu Piso Industrial sin Riesgos y sin contratar múltiples proveedores. Garantía integrada en el PAQUETE SUELO DRM 360™." />
        <meta name="keywords" content="pisos industriales, hormigón alisado, tecnología Sika, pavimentos industriales, Darom SA, Zona Sur GBA" />
        <link rel="canonical" href="https://daromsa.com.ar/services/pisos" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Pisos Industriales y Pavimentos",
            "provider": {
              "@type": "Organization",
              "name": "Darom SA",
              "url": "https://daromsa.com.ar"
            },
            "description": "Construcción de pisos industriales de alta resistencia con tecnología Sika y garantía unificada en la Zona Sur del GBA.",
            "serviceType": "Construction",
            "areaServed": "Buenos Aires - Zona Sur"
          })}
        </script>
      </Helmet>

      {/* 1. HERO SECTION */}
      <section className="pisos-hero-section position-relative">
        <video 
          ref={videoRef}
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 0
          }}
        >
          <source src="/IMG_3315.mp4" type="video/mp4" />
          Tu navegador no soporta videos HTML5.
        </video>
        
        <div className="hero-overlay d-flex align-items-center">
          <Container fluid className="px-0">
            <Row className="justify-content-center mx-0">
              <Col xs={12} className="px-0">
                <div className="hero-content-wrapper w-100 py-5" style={{
                  backgroundColor: 'rgba(49, 49, 49, 0.7)',
                  backdropFilter: 'blur(2px)'
                }}>
                  <Container>
                    <Row className="justify-content-center">
                      <Col xl={9} lg={10} className="text-center">
                        <h1 className="display-4 fw-bold mb-3 text-white">
                          <span className="d-block">CONSTRUÍ TU PISO INDUSTRIAL MÁS RÁPIDO Y</span>
                          <span className="text-red">SIN CONTRATAR MÚLTIPLES PROVEEDORES</span>
                        </h1>
                        
                        <p className="hero-subtitle lead mb-4 text-white">
                          <span className="d-block">PAQUETE SUELO DRM 360™: Todo en Uno</span>
                          <span className="d-block">(Estudio + Movimiento + Hormigón + Garantía)</span>
                        </p>
                        
                        <ul className="hero-features-list list-unstyled mb-4 text-start text-md-center mx-auto" style={{maxWidth: '450px'}}>
                          <li className="mb-2">
                            <span className="check-icon me-2">✓</span>
                            <span className="text-white">Eliminamos sobreprecios ocultos</span>
                          </li>
                          <li className="mb-2">
                            <span className="check-icon me-2">✓</span>
                            <span className="text-white">Evitamos retrasos innecesarios</span>
                          </li>
                          <li className="mb-2">
                            <span className="check-icon me-2">✓</span>
                            <span className="text-white">Garantía de calidad integral</span>
                          </li>
                        </ul>
                        
                        <div className="d-flex flex-column align-items-center">
                          <div className="mb-2">
                            <ContactButton text="HABLA CON UN EXPERTO" />
                          </div>
                          
                          <div className="w-100">
                            <GoogleRatingBadge />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      {/* 2. BENEFICIOS PRINCIPALES */}
      <section className="py-5 bg-white">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="pe-md-5 mb-4 mb-md-0">
              <h2 className="fw-bold mb-4">MÁS DE <span className="text-red">3.000.000 m²</span> CONSTRUIDOS </h2>
              <p className="mb-4">
                Hemos desarrollado un servicio que integra todas las soluciones para pisos industriales:
              </p>
              <ul className="features-list mb-4 list-unstyled">
                <li className="mb-2"><span className="check-icon text-danger fw-bold me-2">✓</span> Control de calidad en tiempo real</li>
                <li className="mb-2"><span className="check-icon text-danger fw-bold me-2">✓</span> Materiales certificados</li>
                <li className="mb-2"><span className="check-icon text-danger fw-bold me-2">✓</span> Responsabilidad total garantizada</li>
              </ul>
              <ContactButton text="CONOCE NUESTRO MÉTODO" />
            </Col>
            <Col md={6}>
              <Row className="text-left stats-row">
                {[
                  { value: "+40", label: "Años de experiencia" },
                  { value: "+3000", label: "Proyectos completados" },
                  { value: "100%", label: "Garantía cumplida" },
                  { value: "25%", label: "Ahorro promedio" }
                ].map((item, idx) => (
                  <Col sm={6} key={idx} className="mb-4">
                    <div className="stat-card p-3 border rounded shadow-sm bg-light h-100">
                      <h3 className="text-red fw-bold">{item.value}</h3>
                      <p className="mb-0 text-muted">{item.label}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 4. PRUEBA SOCIAL */}
      <section className="py-4 bg-light">
        <Container>
          <h2 className="text-center mb-4">EMPRESAS QUE <span className="text-red">CONFÍAN EN NOSOTROS</span></h2>
          
          <div className="suppliers-carousel-container">
            <div className="d-none d-md-block">
              <Carousel indicators={false} interval={3000} pause="hover" touch={true} variant="dark">
                {Array.from({ length: Math.ceil(suppliers.length / 6) }).map((_, slideIndex) => (
                  <Carousel.Item key={`desktop-${slideIndex}`}>
                    <Row className="justify-content-center g-4">
                      {suppliers.slice(slideIndex * 6, (slideIndex + 1) * 6).map((supplier, idx) => (
                        <Col key={`desktop-${slideIndex}-${idx}`} md={2} className="text-center">
                          <div className="supplier-card bg-white p-2 rounded shadow-sm border h-100 d-flex align-items-center justify-content-center">
                            <img 
                              src={supplier.src} 
                              alt={supplier.alt} 
                              className="supplier-logo img-fluid opacity-75" 
                              loading="lazy"
                              style={{maxHeight: '50px', objectFit: 'contain'}}
                            />
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>

            <div className="d-block d-md-none">
              <Carousel indicators={false} interval={3000} pause="hover" touch={true} variant="dark">
                {Array.from({ length: Math.ceil(suppliers.length / 3) }).map((_, slideIndex) => (
                  <Carousel.Item key={`mobile-${slideIndex}`}>
                    <Row className="justify-content-center g-3">
                      {suppliers.slice(slideIndex * 3, (slideIndex + 1) * 3).map((supplier, idx) => (
                        <Col key={`mobile-${slideIndex}-${idx}`} xs={4} className="text-center">
                          <div className="supplier-card bg-white p-2 rounded shadow-sm border h-100 d-flex align-items-center justify-content-center">
                            <img 
                              src={supplier.src} 
                              alt={supplier.alt} 
                              className="supplier-logo img-fluid opacity-75" 
                              loading="lazy"
                              style={{maxHeight: '40px', objectFit: 'contain'}}
                            />
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </div>
        </Container>
      </section>

      {/* 5. TESTIMONIOS */}
      <section id="reviews" className="py-5 bg-white border-top">
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-6 fw-bold mb-3">OPINIONES DE <span className="text-red">NUESTROS CLIENTES</span></h2>
            <div className="d-flex justify-content-center">
              <div className="d-inline-flex align-items-center py-2 px-4 shadow-sm bg-light rounded-pill border">
                <FaGoogle className="text-danger me-2" size={20} />
                <div className="d-flex align-items-center mx-2 border-end border-secondary border-opacity-25 pe-3">
                  <span className="rating-value text-dark fw-bold fs-5 me-1">4.7</span>
                  <FaStar className="text-warning" size={18} />
                </div>
                <span className="text-muted small ms-2 fw-semibold">50+ Reseñas Verificadas</span>
              </div>
            </div>
          </div>
          
          <div className="d-none d-md-block">
            <Carousel indicators={false} interval={4000} variant="dark">
              {[...Array(Math.ceil(testimonios.length / 3))].map((_, i) => (
                <Carousel.Item key={i}>
                  <Row className="g-4 pb-4">
                    {testimonios.slice(i * 3, i * 3 + 3).map((testimonio, idx) => (
                      <Col md={4} key={`d-${i}-${idx}`}>
                        <div className="testimonio-card p-4 h-100 bg-light border rounded shadow-sm text-center">
                          <div className="text-warning mb-2">
                            <FaStar/><FaStar/><FaStar/><FaStar/><FaStar/>
                          </div>
                          <p className="fst-italic text-muted">"{testimonio.text}"</p>
                          <p className="fw-bold mt-3 mb-0 text-dark">— {testimonio.author}</p>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>

          <div className="d-block d-md-none">
            <Carousel indicators={true} interval={4000} variant="dark">
              {testimonios.map((testimonio, idx) => (
                <Carousel.Item key={`m-${idx}`}>
                  <div className="testimonio-card p-4 mx-2 bg-light border rounded shadow-sm text-center mb-4">
                    <div className="text-warning mb-2">
                      <FaStar/><FaStar/><FaStar/><FaStar/><FaStar/>
                    </div>
                    <p className="fst-italic text-muted">"{testimonio.text}"</p>
                    <p className="fw-bold mt-3 mb-0 text-dark">— {testimonio.author}</p>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </Container>
      </section>

      {/* 3. SOLUCIONES/PAQUETES */}
      <section className="py-5 bg-dark">
        <Container>
          <h2 className="fw-bold mb-5 text-center text-white">SOLUCIONES INTEGRALES <span className="text-red">DRM 360™</span></h2>
          <Row className="g-4">
            {paquetesData.map((paquete, idx) => (
              <Col md={4} key={idx}>
                <div className={`paquete-card p-4 h-100 text-dark bg-white rounded shadow ${paquete.premium ? 'border border-danger border-3 position-relative' : ''}`}>
                  {paquete.premium && <div className="position-absolute top-0 start-50 translate-middle badge bg-danger rounded-pill px-3 py-2">RECOMENDADO</div>}
                  <h3 className="text-red fw-bold h4 mb-2 mt-2">{paquete.title}</h3>
                  <p className="fw-bold text-muted small">"{paquete.subtitle}"</p>
                  <ul className="mb-4 list-unstyled text-muted small">
                    {paquete.features.map((feature, i) => (
                      <li key={i} className="mb-2"><span className="text-success fw-bold me-2">✓</span> {feature}</li>
                    ))}
                  </ul>
                  <div className="garantia-box mb-3 bg-light p-3 rounded border">
                    <h5 className="text-red fs-6 fw-bold">GARANTÍA TÉCNICA</h5>
                    <p className="small mb-0 text-muted">{paquete.garantia}</p>
                  </div>
                  <ContactButton 
                    text="COTIZAR PAQUETE" 
                    variant={paquete.premium ? "danger" : "outline-danger"}
                    className="w-100"
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* PROYECTOS RECIENTES */}
      <section className="py-5 bg-light">
        <Container>
          <h2 className="text-center mb-5">PROYECTOS <span className="text-red">RECIENTES</span></h2>
          
          <div className="d-md-none">
            <Carousel indicators={false} interval={null} variant="dark">
              {[...Array(Math.ceil(obras.length / 2))].map((_, index) => (
                <Carousel.Item key={index}>
                  <div className="d-flex justify-content-center px-2">
                    {obras.slice(index * 2, index * 2 + 2).map((obra, idx) => (
                      <div key={idx} className="mx-1" style={{ width: '48%' }}>
                        <div className="obra-card rounded overflow-hidden shadow-sm bg-white">
                          <img src={obra} alt="Obra realizada" className="img-fluid w-100" style={{height: '150px', objectFit: 'cover'}} loading="lazy" />
                        </div>
                      </div>
                    ))}
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
          
          <Row className="g-3 obra-gallery d-none d-md-flex">
            {obras.map((obra, idx) => (
              <Col md={4} sm={6} key={idx}>
                <div className="obra-card rounded overflow-hidden shadow-sm bg-white border h-100">
                  <img src={obra} alt="Obra realizada" className="img-fluid w-100" style={{height: '220px', objectFit: 'cover'}} loading="lazy" />
                </div>
              </Col>
            ))}
          </Row>
          
          <div className="text-center mt-5">
            <ContactButton text="VER MÁS PROYECTOS" />
          </div>
        </Container>
      </section>

      {/* PROCESO SIMPLIFICADO */}
      <section className="py-5 bg-white">
        <Container className="text-center">
          <h2 className="mb-3 fw-bold">Comenzar es Muy Sencillo</h2>
          <p className="text-muted mb-5">En solo 3 pasos, podés tener el piso industrial que tu empresa necesita, sin complicaciones.</p>
          
          <Row className="g-4 position-relative">
            <Col md={4} className="position-relative">
              <div className="bg-light p-4 rounded shadow-sm h-100 border-top border-3 border-danger text-center">
                <div className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3 shadow" style={{width: '50px', height: '50px', fontSize: '1.5rem', fontWeight: 'bold'}}>1</div>
                <h3 className="h5 fw-bold">Agendá tu Diagnóstico</h3>
                <p className="text-muted small">Contactanos por WhatsApp y coordinamos una visita sin cargo para evaluar tu proyecto.</p>
              </div>
            </Col>
            
            <Col md={4} className="position-relative">
              <div className="bg-light p-4 rounded shadow-sm h-100 border-top border-3 border-danger text-center">
                <div className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3 shadow" style={{width: '50px', height: '50px', fontSize: '1.5rem', fontWeight: 'bold'}}>2</div>
                <h3 className="h5 fw-bold">Recibí tu Propuesta</h3>
                <p className="text-muted small">En 48 hs hábiles, te presentamos un plan detallado y personalizado con la mejor solución.</p>
              </div>
            </Col>
            
            <Col md={4} className="position-relative">
              <div className="bg-light p-4 rounded shadow-sm h-100 border-top border-3 border-danger text-center">
                <div className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3 shadow" style={{width: '50px', height: '50px', fontSize: '1.5rem', fontWeight: 'bold'}}>3</div>
                <h3 className="h5 fw-bold">Iniciamos la Obra</h3>
                <p className="text-muted small">Con todo aprobado, ponemos manos a la obra para construir tu piso industrial ideal.</p>
              </div>
            </Col>
          </Row>
          
          <div className="mt-4">
            <ContactButton 
              text="Agendar Diagnóstico Ahora por WhatsApp" 
              variant="danger" 
              className="px-4 py-3 fw-bold shadow" 
            />
          </div>
        </Container>
      </section>

      {/* SOLUCIÓN INTEGRAL DRM360 */}
      <section className="py-5 bg-light border-top">
        <Container className="text-center">
          <h2 className="mb-3 fw-bold">DRM360™: Tu Camino Simplificado al Piso Industrial Perfecto</h2>
          <p className="text-muted mb-5 mx-auto" style={{maxWidth: '700px'}}>Olvidate de coordinar múltiples proveedores. Con nuestro sistema 4-en-1, gestionamos todo por vos, garantizando calidad y eficiencia de punta a punta.</p>
          
          <Row className="g-4 justify-content-center">
            <Col lg={3} md={6}>
              <div className="bg-white p-4 rounded shadow-sm h-100 border text-center">
                <div className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3 fw-bold" style={{width: '40px', height: '40px', fontSize: '1.25rem'}}>1</div>
                <h4 className="h5 text-danger fw-bold">Estudio de Suelo</h4>
                <p className="text-muted small mb-0">Análisis geotécnico y topográfico preciso para una base sin sorpresas.</p>
              </div>
            </Col>
            
            <Col lg={3} md={6}>
              <div className="bg-white p-4 rounded shadow-sm h-100 border text-center">
                <div className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3 fw-bold" style={{width: '40px', height: '40px', fontSize: '1.25rem'}}>2</div>
                <h4 className="h5 text-danger fw-bold">Movimiento de Suelo</h4>
                <p className="text-muted small mb-0">Preparación y compactación certificada del terreno con control en tiempo real.</p>
              </div>
            </Col>
            
            <Col lg={3} md={6}>
              <div className="bg-white p-4 rounded shadow-sm h-100 border text-center">
                <div className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3 fw-bold" style={{width: '40px', height: '40px', fontSize: '1.25rem'}}>3</div>
                <h4 className="h5 text-danger fw-bold">Hormigón Certificado</h4>
                <p className="text-muted small mb-0">Calidad controlada con laboratorio in-situ, tickets de pesada y rastreo satelital.</p>
              </div>
            </Col>
            
            <Col lg={3} md={6}>
              <div className="bg-white p-4 rounded shadow-sm h-100 border text-center">
                <div className="bg-danger text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3 fw-bold" style={{width: '40px', height: '40px', fontSize: '1.25rem'}}>4</div>
                <h4 className="h5 text-danger fw-bold">Garantía Unificada</h4>
                <p className="text-muted small mb-0">Cobertura integral FULLCOVER™ que te protege ante cualquier eventualidad.</p>
              </div>
            </Col>
          </Row>
          
          <div className="mt-5">
            <img 
              src="/Gemini_Generated_Image_9jdci99jdci99jdc.png" 
              alt="Esquema Visual Proceso DRM360" 
              className="img-fluid rounded shadow" 
              style={{maxHeight: '400px', objectFit: 'cover'}}
              onError={(e) => {
                e.target.onerror = null; 
                e.target.src = "/img/placeholder-proceso.jpg";
              }} 
            />
          </div>
        </Container>
      </section>

      {/* 7. CTA FINAL */}
      <section className="py-5 bg-danger text-white">
        <Container className="text-center">
          <h2 className="mb-4 fw-bold">¿LISTO PARA TRANSFORMAR TUS PISOS INDUSTRIALES?</h2>
          <div className="lead mb-4 mx-auto" style={{maxWidth: '650px'}}>
            <CheckListItem text="Obtén una evaluación gratuita con nuestros especialistas" />
            <CheckListItem text="Servicio sin retrasos por falta de coordinación entre proveedores" />
            <CheckListItem text="Sin sobreprecios al contratar servicios por separado" />
            <CheckListItem text="4 servicios en 1, con garantía unificada FULLCOVER™" />
          </div>
          <ContactButton 
            text="CONTACTAR AHORA" 
            variant="light" 
            className="px-5 py-3 fw-bold shadow text-danger" 
          />
        </Container>
      </section>

    </Container>
  );
}

export default Pisos;